import p from "./ghl-ui.es1589.js";
import f from "./ghl-ui.es1590.js";
import m from "./ghl-ui.es1586.js";
import c from "./ghl-ui.es1587.js";
import l from "./ghl-ui.es1588.js";
import n from "./ghl-ui.es1591.js";
import { Parser as h } from "./ghl-ui.es1670.js";
import { numericPatterns as v } from "./ghl-ui.es1672.js";
import { parseNDigits as k, parseNumericPattern as d } from "./ghl-ui.es1671.js";
import w from "./ghl-ui.es1673.js";
import P from "./ghl-ui.es1467.js";
var U = /* @__PURE__ */ function(u) {
  c(i, u);
  var o = l(i);
  function i() {
    var a;
    p(this, i);
    for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
      e[t] = arguments[t];
    return a = o.call.apply(o, [this].concat(e)), n(m(a), "priority", 100), n(m(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return f(i, [{
    key: "parse",
    value: function(r, e, t) {
      switch (e) {
        case "w":
          return d(v.week, r);
        case "wo":
          return t.ordinalNumber(r, {
            unit: "week"
          });
        default:
          return k(e.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, e) {
      return e >= 1 && e <= 53;
    }
  }, {
    key: "set",
    value: function(r, e, t, s) {
      return P(w(r, t, s), s);
    }
  }]), i;
}(h);
export {
  U as LocalWeekParser
};
